import { useMemo } from 'react'

import { DashboardNoSpenderListRestEndpointService } from '@api'
import { useInfiniteQuery } from 'react-query'

export function useGetNoSpenderListFans(
  creatorId: number,
  listId: number,
  search: string,
) {
  const {
    data,
    isFetching,
    isLoading,
    error,
    isSuccess,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ['creator', creatorId, 'no-spenders', listId, 'fans', search],
    queryFn: ({ pageParam = 0 }) =>
      DashboardNoSpenderListRestEndpointService.dashboardGetNoSpenderListFans({
        creatorId,
        listId,
        page: pageParam,
        fanName: search,
      }),
    getNextPageParam: (lastPage) => {
      if (
        lastPage.last ||
        lastPage.number === undefined ||
        lastPage.totalPages === undefined ||
        lastPage.number === lastPage.totalPages
      ) {
        return undefined
      }

      if (lastPage.number < lastPage.totalPages) {
        return lastPage.number + 1
      }

      return undefined
    },
    staleTime: 2 * 60 * 1000,
    enabled: !!creatorId && !!listId,
  })

  const fans = useMemo(
    () => data?.pages.flatMap((page) => page.content ?? []) ?? [],
    [data?.pages],
  )

  return {
    fans,
    isFetching,
    isLoading,
    error,
    isSuccess,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  }
}
